export default "__VITE_ASSET__BGxzcJY1__"